import React, { useEffect, useState } from 'react'
import CRMLayout from '../../../../../../layout/components/CRMLayout'
import LeadForm from '../components/LeadForm';
import leadServices from '../leadServices';
import { CircularProgress } from '@mui/material';
import { useAppData } from '../../../../../../context/AppDataContext';
import { Add } from '@mui/icons-material';
import { useFilteredLead } from '../hook/useFilteredLead';
import LeadInfo from '../components/LeadInfo';
import { Link } from 'react-router-dom';

function LeadDashboardPage() {

    const [loading,setLoadingStatus] = useState(false)
    const [leadList,setLeadList] = useState();

    const {masters} = useAppData();


    const getLeadList = () =>{
        setLoadingStatus(true);
        leadServices.getList().then(res=>{
            setLeadList(res.data);
        }).catch(error=>{

        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    useEffect(()=>{
        getLeadList();
    },[])


    const { mine, highPriority, byStatus } = useFilteredLead(leadList, masters['lead-status']);

    return (
        <CRMLayout>
            <div className='row'>
                <div className='col-md-6'>
                    <LeadForm callBack={getLeadList} />
                </div>
                <div className='col-md-6'>
                    <span className='float-end'>
                        <Link to={"/lead/list"} className='btn btn-outline-primary me-2'>List View</Link>
                    </span>
                </div>
            </div>
            {loading && <div className='mt-5'><CircularProgress /></div>}
            {!loading &&
                
                <div className='row mt-2'>
                    {leadList?.length == 0 &&
                        <div className='col-md-12'>
                            <div className="alert alert-info" role="alert">
                                <h4 className="alert-heading">No Leads</h4>
                                <p>No Leads Available.</p>
                                <hr/>
                                <p className="mb-0">Click on new Lead to <span className='fw-bold'><Add/> New Lead </span> button to add lead</p>
                            </div>
                        </div>
                    }
                    
                    
                    {leadList?.length > 0 && (
                        <div 
                            className="d-flex flex-row flex-nowrap overflow-auto pb-3 gap-3" 
                            style={{ width: '100%', scrollbarWidth: 'thin' }}
                        >
                            {byStatus.map(leadStatus => {
                                // Calculate total estimated value for this status column
                                const totalStatusValue = leadStatus.leads.reduce((sum, lead) => {
                                    return sum + (Number(lead.estimatedValue) || 0);
                                }, 0);

                                return (
                                    <div 
                                        key={leadStatus.value} 
                                        style={{ minWidth: '280px', maxWidth: '280px', flex: '0 0 auto' }}
                                    >
                                        <div className='card shadow-sm h-100 border-0'>
                                            {/* Redesigned Status Header with Total Est. Value */}
                                            <div className='card-header bg-white py-3 border-bottom'>
                                                <div className='d-flex justify-content-between align-items-center mb-1'>
                                                    <span className='fw-bold text-dark' style={{ fontSize: '14px' }}>
                                                        {leadStatus.label}
                                                    </span>
                                                    <span className='badge bg-primary rounded-pill' style={{ fontSize: '11px' }}>
                                                        {leadStatus.leads.length}
                                                    </span>
                                                </div>
                                                <div className='d-flex justify-content-between align-items-center'>
                                                    <span className='text-muted' style={{ fontSize: '11px' }}>Total Est:</span>
                                                    <span className='text-success fw-bold' style={{ fontSize: '12px' }}>
                                                        ₹{totalStatusValue.toLocaleString()}
                                                    </span>
                                                </div>
                                            </div>

                                            {/* Leads Container with Vertical Scrolling */}
                                            <div 
                                                className='card-body p-2' 
                                                style={{ 
                                                    maxHeight: 'calc(100vh - 280px)', 
                                                    overflowY: 'auto',
                                                    backgroundColor: '#f8f9fa' 
                                                }}
                                            >
                                                {leadStatus.leads.length === 0 ? (
                                                    <div className="alert alert-light text-muted text-center py-4 mb-0 border-0" role="alert">
                                                        <small>No leads here...</small>
                                                    </div>
                                                ) : (
                                                    leadStatus.leads.map(lead => (
                                                        <div key={lead.id} className="bg-white rounded p-2 mb-2 shadow-sm border">
                                                            <LeadInfo leadDetails={lead} callBack={getLeadList} />
                                                        </div>
                                                    ))
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                    {/*
                    <pre className="bg-light p-3 border rounded text-dark" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                        {JSON.stringify(byStatus,null,2)}
                    </pre>
                    */}

                    
                </div>
            }
        </CRMLayout>
    )
}

export default LeadDashboardPage